var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{class:_vm.textColor,attrs:{"color":_vm.alertColor,"tile":"","elevation":"2"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.item.caption)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }